import { i18n as _i18n } from "@lingui/core";
import { formNames } from '@wkda/carlead-creation-form';
import { useModulesStore } from '@wkda/funnel-components';
import { GenericFieldBoxSelect } from './GenericFieldBoxSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export function SplitBodyTypes(_ref) {
  let {
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.bodyType'
    }),
    ...props
  } = _ref;
  const {
    carTypesSplitModule: {
      getBodyTypes
    }
  } = useModulesStore();
  return /*#__PURE__*/_jsx(GenericFieldBoxSelect, {
    columnClassName: "col-6",
    label: label,
    dataQueryFn: getBodyTypes,
    name: formNames.bodyType,
    ...props
  });
}